export const PAGE_STATE_CACHES = {
  ReviewIncomingApps: 'ReviewIncomingApps',
};



// WEBPACK FOOTER //
// ./src/state/pagestatecache/helpers/Constants.js